import React from 'react'
import './index.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashCan } from '@fortawesome/free-solid-svg-icons'

const Index = ({Action}) => {
  return (
    <div className='panelcontrols_paneltablebuttons_delete'>
      <button onClick={Action}><FontAwesomeIcon icon={faTrashCan}/></button>
    </div>
  )
}

export default Index
